import { type FormEvent, useState } from "react";
import { Icon } from "./Icon";
import { InlineInput, InlineInputButton, InlineInputForm } from "./InlineInput";
import { SignInLayout } from "./SignIn/shared";

export function CompleteProfile({
  onSubmit,
}: {
  onSubmit: (name: string) => void;
}) {
  const [name, setName] = useState("");

  const canSubmit = name.trim().length > 0;

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit(name.trim());
  };

  return (
    <SignInLayout title="What's your name?">
      <InlineInputForm onSubmit={submit}>
        <InlineInput
          autoFocus
          placeholder="Full name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InlineInputButton
          type="submit"
          disabled={!canSubmit}
          aria-label="Continue"
        >
          <Icon name="arrow-right" size={16} />
        </InlineInputButton>
      </InlineInputForm>
    </SignInLayout>
  );
}
